import labelInputMixin from "../_mixin";
export default {
  name: "commonTimeSelect",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-time-select", data);
    }
  },
};
